import { formatLocationObject, getMapStateAndMarketsForLocation } from '../'

export const handleSearchByBrowserGeolocation = ({ token, mapState }) => {
  const onSuccess = async position => {
    try {
      const location = formatLocationObject(position.coords, 'GOOGLE_MAPS')
      const { mapState: newMapState, markets: marketsForLocation } =
        await getMapStateAndMarketsForLocation(location, token, mapState)

      return {
        markets: marketsForLocation,
        isExactSearch: true,
        mapState: { ...mapState, ...newMapState }
      }
    } catch (error) {
      console.log('error: ', error.message)
      return null
    }
  }

  const onError = error => {
    // throw error
    console.log(error)
    return null
  }

  const location = () => {
    return new Promise((res, rej) =>
      navigator.geolocation.getCurrentPosition(res, rej)
    )
  }

  const getPositionData = async () => {
    try {
      const position = await location()
      return onSuccess(position)
    } catch (error) {
      return onError(error)
    }
  }

  return getPositionData()
}
